import { axiosInstance } from 'utils/http';
import { flow } from 'utils/urlConstants';
import { showAlert } from 'redux/actions/AlertActions';
import { useDispatch, useSelector } from 'react-redux';
import { useMutation } from 'react-query';


export const useDeleteFlowVersion = (crId, flowId) => {
  const dispatch = useDispatch();
  const orgId = useSelector(state => state.session.user.primaryOrganization.organization.ID);
  const {
    isLoading, isError, isSuccess, mutate, reset,
  } = useMutation(
    ['delete-flow-version', orgId, flowId],
    async ({ version, ...payload }) => (
      axiosInstance.delete(flow(orgId).deleteFlowVersion(crId, flowId, version), payload)
    ),
    {
      onSuccess: (_, requestPayload) => (
        dispatch(showAlert({ message: `Flow version v${requestPayload.version} has been deleted.`, type: 'success' }))
      ),
      onError: (error) => dispatch(showAlert({ message: error.response.data.message, type: 'error' })),
    },
  );
  return {
    isLoading, isError, isSuccess, mutate, reset,
  };
};
